(function () {
  'use strict';

  function formatMoney(cents, format) {
    if (window.theme && window.theme.Currency && typeof window.theme.Currency.formatMoney === 'function') {
      return window.theme.Currency.formatMoney(cents, format || window.theme.settings.moneyFormat);
    }

    var amount = (Number(cents || 0) / 100).toFixed(2);
    return (format || '${{amount}}')
      .replace(/\{\{\s*amount_no_decimals\s*\}\}/, String(Math.round(Number(amount))))
      .replace(/\{\{\s*amount\s*\}\}/, amount);
  }

  function getVariantImage(variant) {
    if (!variant || !variant.featured_image) return '';
    return variant.featured_image.src || variant.featured_image.url || '';
  }

  function getVariantMediaId(variant) {
    if (!variant) return '';
    if (variant.featured_media && variant.featured_media.id) return String(variant.featured_media.id);
    if (variant.featured_image && variant.featured_image.id) return String(variant.featured_image.id);
    return '';
  }

  function initGallery(root) {
    var gallery = root ? root.querySelector('[data-jb2-gallery]') : null;
    if (!gallery || gallery.dataset.jb2Initialized === 'true') return gallery && gallery.jb2Gallery;
    gallery.dataset.jb2Initialized = 'true';

    var slides = Array.prototype.slice.call(gallery.querySelectorAll('[data-jb2-gallery-slide]'));
    var thumbs = Array.prototype.slice.call(gallery.querySelectorAll('[data-jb2-gallery-thumb]'));
    var stage = gallery.querySelector('[data-jb2-gallery-stage]');
    var counter = gallery.querySelector('[data-jb2-gallery-current]');
    var currentIndex = Math.max(0, slides.findIndex(function (slide) { return slide.classList.contains('is-active'); }));
    var touchStartX = null;

    if (!slides.length) return null;

    function pauseMedia(slide) {
      if (!slide) return;
      slide.querySelectorAll('video').forEach(function (video) { video.pause(); });
    }

    function showAt(index, moveFocus) {
      if (!slides.length) return;
      currentIndex = (index + slides.length) % slides.length;
      var activeSlide = slides[currentIndex];
      var key = activeSlide.dataset.jb2GallerySlide;

      slides.forEach(function (slide, slideIndex) {
        var active = slideIndex === currentIndex;
        if (!active) pauseMedia(slide);
        slide.classList.toggle('is-active', active);
        slide.hidden = !active;
      });

      thumbs.forEach(function (thumb) {
        var active = thumb.dataset.jb2GalleryThumb === key;
        thumb.classList.toggle('is-active', active);
        thumb.setAttribute('aria-selected', active ? 'true' : 'false');
        thumb.tabIndex = active ? 0 : -1;
        if (active) {
          thumb.scrollIntoView({ block: 'nearest', inline: 'nearest', behavior: 'smooth' });
          if (moveFocus) thumb.focus();
        }
      });

      if (counter) counter.textContent = String(currentIndex + 1);
    }

    function showKey(key, moveFocus) {
      var index = slides.findIndex(function (slide) {
        return String(slide.dataset.jb2GallerySlide) === String(key);
      });
      if (index >= 0) showAt(index, moveFocus);
      return index >= 0;
    }

    thumbs.forEach(function (thumb) {
      thumb.addEventListener('click', function () { showKey(thumb.dataset.jb2GalleryThumb, false); });
      thumb.addEventListener('keydown', function (event) {
        if (!['ArrowUp', 'ArrowDown', 'ArrowLeft', 'ArrowRight', 'Home', 'End'].includes(event.key)) return;
        event.preventDefault();
        if (event.key === 'Home') showAt(0, true);
        else if (event.key === 'End') showAt(slides.length - 1, true);
        else if (event.key === 'ArrowUp' || event.key === 'ArrowLeft') showAt(currentIndex - 1, true);
        else showAt(currentIndex + 1, true);
      });
    });

    var previous = gallery.querySelector('[data-jb2-gallery-prev]');
    var next = gallery.querySelector('[data-jb2-gallery-next]');
    if (previous) previous.addEventListener('click', function () { showAt(currentIndex - 1, false); });
    if (next) next.addEventListener('click', function () { showAt(currentIndex + 1, false); });

    if (stage) {
      stage.tabIndex = 0;
      stage.addEventListener('keydown', function (event) {
        if (event.key !== 'ArrowLeft' && event.key !== 'ArrowRight') return;
        event.preventDefault();
        showAt(currentIndex + (event.key === 'ArrowRight' ? 1 : -1), false);
      });
      stage.addEventListener('touchstart', function (event) {
        touchStartX = event.touches && event.touches[0] ? event.touches[0].clientX : null;
      }, { passive: true });
      stage.addEventListener('touchend', function (event) {
        if (touchStartX === null || !event.changedTouches || !event.changedTouches[0]) return;
        var distance = event.changedTouches[0].clientX - touchStartX;
        touchStartX = null;
        if (Math.abs(distance) > 45) showAt(currentIndex + (distance < 0 ? 1 : -1), false);
      }, { passive: true });
    }

    gallery.jb2Gallery = { showKey: showKey, showAt: showAt };
    showAt(currentIndex, false);
    return gallery.jb2Gallery;
  }

  function initProduct(root) {
    if (!root || root.dataset.jb2Initialized === 'true') return;
    root.dataset.jb2Initialized = 'true';

    var json = root.querySelector('[data-jb2-product-json]');
    var product;

    try {
      product = JSON.parse(json ? json.textContent : '{}');
    } catch (error) {
      product = null;
    }

    if (!product || !Array.isArray(product.variants)) return;

    var form = root.querySelector('.jb2pdp-product__form');
    var variantInput = root.querySelector('[data-jb2-variant-id]');
    var quantityInput = root.querySelector('[data-jb2-quantity-input]');
    var quantityValue = root.querySelector('[data-jb2-quantity-value]');
    var addButton = root.querySelector('[data-jb2-add]');
    var addText = root.querySelector('[data-jb2-add-text]');
    var price = root.querySelector('[data-jb2-price]');
    var inventory = root.querySelector('[data-jb2-inventory]');
    var gallery = initGallery(root);
    var image = root.querySelector('[data-jb2-gallery-slide].is-active .jb2pdp-product__image');
    var message = root.querySelector('[data-jb2-form-message]');
    var moneyFormat = root.dataset.moneyFormat;
    var selected = {};
    var quantity = 1;
    var currentVariant = product.variants.find(function (variant) {
      return String(variant.id) === String(variantInput ? variantInput.value : '');
    }) || product.variants[0];

    function variantOptions(variant) {
      if (!variant) return [];
      if (Array.isArray(variant.options)) return variant.options;
      return [variant.option1, variant.option2, variant.option3].filter(function (value) {
        return value !== null && typeof value !== 'undefined';
      });
    }

    function findVariantById(id) {
      if (!id) return null;
      return product.variants.find(function (variant) {
        return String(variant.id) === String(id);
      }) || null;
    }

    function getQuantityRule() {
      var rule = currentVariant && currentVariant.quantity_rule ? currentVariant.quantity_rule : {};
      var minimum = Math.max(1, Number(rule.min || 1));
      var increment = Math.max(1, Number(rule.increment || 1));
      var maximum = rule.max === null || typeof rule.max === 'undefined' || rule.max === ''
        ? null
        : Math.max(minimum, Number(rule.max));

      return { min: minimum, max: maximum, increment: increment };
    }

    function normalizeQuantity(value) {
      var rule = getQuantityRule();
      var normalized = Math.max(rule.min, Number(value || rule.min));
      normalized = rule.min + Math.round((normalized - rule.min) / rule.increment) * rule.increment;
      if (rule.max !== null) normalized = Math.min(rule.max, normalized);
      return normalized;
    }

    function syncSelectionFromVariant(variant) {
      variantOptions(variant).forEach(function (value, index) {
        selected[String(index + 1)] = value;
      });

      root.querySelectorAll('[data-jb2-option-position]').forEach(function (button) {
        var position = button.dataset.jb2OptionPosition;
        var active = selected[position] === button.dataset.jb2OptionValue;
        button.classList.toggle('is-selected', active);
        button.setAttribute('aria-pressed', active ? 'true' : 'false');
      });

      Object.keys(selected).forEach(function (position) {
        var optionLabel = root.querySelector('[data-jb2-option-label="' + position + '"]');
        if (optionLabel) optionLabel.textContent = selected[position];
      });
    }

    function findSelectedVariant() {
      return product.variants.find(function (variant) {
        return variantOptions(variant).every(function (value, index) {
          var chosen = selected[String(index + 1)];
          return !chosen || chosen === value;
        });
      }) || null;
    }

    function updateOptionAvailability() {
      root.querySelectorAll('[data-jb2-option-position]').forEach(function (button) {
        var position = Number(button.dataset.jb2OptionPosition) - 1;
        var candidateValue = button.dataset.jb2OptionValue;
        var compatible = product.variants.filter(function (variant) {
          var options = variantOptions(variant);
          if (options[position] !== candidateValue) return false;

          return options.every(function (value, index) {
            if (index === position) return true;
            var chosen = selected[String(index + 1)];
            return !chosen || chosen === value;
          });
        });
        var available = compatible.some(function (variant) { return Boolean(variant.available); });
        var optionName = button.dataset.jb2OptionName || 'Option';
        var label = optionName + ': ' + candidateValue + (available ? '' : ' (sold out)');

        button.classList.toggle('is-unavailable', !available);
        button.dataset.jb2OptionAvailable = available ? 'true' : 'false';
        button.setAttribute('aria-label', label);
      });
    }

    function renderInventory() {
      if (!inventory || !currentVariant) return;

      var state = 'in-stock';
      var label = inventory.dataset.inStockLabel || 'In stock';
      var managed = Boolean(currentVariant.inventory_management);
      var inventoryQuantity = Number(currentVariant.inventory_quantity || 0);
      var threshold = Number(inventory.dataset.lowThreshold || 0);
      var showCount = inventory.dataset.showCount === 'true';

      if (!currentVariant.available) {
        state = 'sold-out';
        label = inventory.dataset.soldOutLabel || 'Sold out';
      } else if (managed && inventoryQuantity <= 0 && currentVariant.inventory_policy === 'continue') {
        state = 'backorder';
        label = inventory.dataset.backorderLabel || 'Available to order';
      } else if (managed && showCount && inventoryQuantity > 0 && inventoryQuantity <= threshold) {
        state = 'low-stock';
        label = (inventory.dataset.lowStockLabel || 'Only [quantity] left in stock')
          .replace('[quantity]', String(inventoryQuantity));
      }

      inventory.classList.remove('is-in-stock', 'is-low-stock', 'is-backorder', 'is-sold-out');
      inventory.classList.add('is-' + state);
      inventory.textContent = label;
    }

    function renderState() {
      if (!currentVariant) return;

      var available = Boolean(currentVariant.available);
      var unitPrice = Number(currentVariant.price || 0);
      var buttonLabel = addButton ? addButton.dataset.buttonLabel : 'ADD TO CART';
      var soldOutLabel = addButton ? addButton.dataset.soldOutLabel : 'SOLD OUT';
      quantity = normalizeQuantity(quantity);

      syncSelectionFromVariant(currentVariant);
      updateOptionAvailability();
      renderInventory();

      if (variantInput) variantInput.value = currentVariant.id;
      if (quantityInput) quantityInput.value = quantity;
      if (quantityValue) quantityValue.textContent = quantity;
      if (price) price.innerHTML = formatMoney(unitPrice, moneyFormat);
      if (addButton) addButton.disabled = !available;
      if (addText) {
        addText.textContent = available
          ? buttonLabel + ' — ' + formatMoney(unitPrice * quantity, moneyFormat)
          : soldOutLabel;
      }

      document.querySelectorAll('[data-jb2-cta-price]').forEach(function (node) {
        node.innerHTML = formatMoney(unitPrice, moneyFormat);
      });
      document.querySelectorAll('[data-jb2-cta-add]').forEach(function (button) {
        button.disabled = !available;
      });
      document.querySelectorAll('[data-jb2-compare-price]').forEach(function (node) {
        node.innerHTML = formatMoney(unitPrice, moneyFormat);
      });

      document.dispatchEvent(new CustomEvent('jb2:variant-change', {
        detail: { variant: currentVariant, quantity: quantity }
      }));
    }

    function updateImage(variant) {
      var mediaId = getVariantMediaId(variant);
      if (gallery && mediaId && gallery.showKey(mediaId, false)) return;

      var source = getVariantImage(variant);
      if (!image || !source || image.src === source) return;

      image.classList.add('is-changing');
      image.removeAttribute('srcset');
      image.removeAttribute('sizes');
      image.onload = function () {
        image.classList.remove('is-changing');
        image.onload = null;
      };
      image.src = source;
      image.alt = variant.title || product.title;
    }

    root.querySelectorAll('[data-jb2-option-position]').forEach(function (button) {
      button.addEventListener('click', function () {
        var position = button.dataset.jb2OptionPosition;
        selected[position] = button.dataset.jb2OptionValue;
        var match = findSelectedVariant();

        if (!match) {
          match = findVariantById(button.dataset.jb2OptionVariantId);
        }

        if (!match) {
          var optionIndex = Number(position) - 1;
          var candidates = product.variants.filter(function (variant) {
            return variantOptions(variant)[optionIndex] === button.dataset.jb2OptionValue;
          });
          match = candidates.find(function (variant) { return Boolean(variant.available); }) || candidates[0];
        }

        if (!match) return;
        currentVariant = match;
        quantity = getQuantityRule().min;
        renderState();
        updateImage(currentVariant);

        if (window.history && window.history.replaceState) {
          var url = new URL(window.location.href);
          url.searchParams.set('variant', currentVariant.id);
          window.history.replaceState({}, '', url.toString());
        }
      });
    });

    root.querySelectorAll('[data-jb2-quantity]').forEach(function (button) {
      button.addEventListener('click', function () {
        var direction = Number(button.dataset.jb2Quantity || 0);
        var rule = getQuantityRule();
        quantity = normalizeQuantity(quantity + direction * rule.increment);
        renderState();
      });
    });

    if (form) {
      form.addEventListener('submit', function (event) {
        event.preventDefault();
        if (!currentVariant || !currentVariant.available || !addButton || addButton.disabled) return;

        addButton.disabled = true;
        addButton.classList.add('is-loading');
        addButton.setAttribute('aria-busy', 'true');
        if (message) {
          message.textContent = '';
          message.classList.remove('is-success');
        }

        var endpoint = window.theme && window.theme.routes
          ? window.theme.routes.cartAdd
          : ((window.Shopify && window.Shopify.routes ? window.Shopify.routes.root : '/') + 'cart/add.js');

        fetch(endpoint, {
          method: 'POST',
          headers: {
            'X-Requested-With': 'XMLHttpRequest',
            'Accept': 'application/json'
          },
          body: new FormData(form)
        })
          .then(function (response) {
            return response.json().then(function (data) {
              if (!response.ok) throw data;
              return data;
            });
          })
          .then(function (item) {
            quantity = getQuantityRule().min;
            renderState();
            if (message) {
              message.textContent = 'Added to cart.';
              message.classList.add('is-success');
            }

            document.dispatchEvent(new CustomEvent('ajaxProduct:added', {
              detail: { product: item, addToCartBtn: addButton }
            }));

            return fetch((window.Shopify && window.Shopify.routes ? window.Shopify.routes.root : '/') + 'cart.js')
              .then(function (response) { return response.json(); })
              .then(function (cart) {
                document.dispatchEvent(new CustomEvent('cart:updated', { detail: { cart: cart } }));
                if (window.theme && window.theme.settings && window.theme.settings.cartType === 'page') {
                  window.location.href = window.theme.routes.cartPage;
                }
              });
          })
          .catch(function (error) {
            if (message) {
              message.textContent = error.description || error.message || 'We could not add this item. Please try again.';
              message.classList.remove('is-success');
            }
          })
          .finally(function () {
            addButton.classList.remove('is-loading');
            addButton.removeAttribute('aria-busy');
            addButton.disabled = !currentVariant.available;
          });
      });
    }

    syncSelectionFromVariant(currentVariant);
    quantity = getQuantityRule().min;
    renderState();
  }

  function initCta(button) {
    if (!button || button.dataset.jb2Initialized === 'true') return;
    button.dataset.jb2Initialized = 'true';
    button.addEventListener('click', function () {
      var form = document.querySelector('[data-jb2-product] .jb2pdp-product__form');
      var submit = form ? form.querySelector('[data-jb2-add]') : null;
      if (form && submit && !submit.disabled) {
        if (typeof form.requestSubmit === 'function') form.requestSubmit(submit);
        else submit.click();
      } else {
        var productSection = document.querySelector('[data-jb2-product]');
        if (productSection) productSection.scrollIntoView({ behavior: 'smooth', block: 'start' });
      }
    });
  }

  function init(scope) {
    (scope || document).querySelectorAll('[data-jb2-product]').forEach(initProduct);
    (scope || document).querySelectorAll('[data-jb2-cta-add]').forEach(initCta);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { init(document); });
  } else {
    init(document);
  }

  document.addEventListener('shopify:section:load', function (event) {
    init(event.target);
  });
})();
